// extracted by mini-css-extract-plugin
module.exports = {"caption":"_3d9qJDIx9VrD8hdm5CqiVo"};